import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import ClickEaterFactory from "../../../../core/ui/ClickEaterFactory";
import Graph from "../../../components/graphs/Graph";
import GraphAxesDisplayOptions from "../../../components/graphs/GraphAxesDisplayOptions";
import GraphAxisDisplayOptions from "../../../components/graphs/GraphAxisDisplayOptions";
import GraphAxisIntervalDisplayOptions from "../../../components/graphs/GraphAxisIntervalDisplayOptions";
import GraphAxisLegendDisplayOptions from "../../../components/graphs/GraphAxisLegendDisplayOptions";
import LineGraphDisplayOptions from "../../../components/graphs/LineGraphDisplayOptions";
import Vector2 from "../../../components/graphs/Vector2";
import DashboardNumberChartFactory from "../../controller/DashboardNumberChartFactory";
import DashboardConfig from "../../model/DashboardConfig";
import DashboardData from "../../model/DashboardData";
import DashboardTabMediator from "./DashboardTabMediator";
export default class DashboardEpiTabMediator extends DashboardTabMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {LanguagePack} languagePack 
     * @param {DashboardNumberChartFactory} dashboardNumberChartFactory 
     * @param {DashboardConfig} dashboardConfig 
     * @param {DashboardData} dashboardData 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, dashboardNumberChartFactory, dashboardConfig, dashboardData, progressGameModel) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._dashboardNumberChartFactory = dashboardNumberChartFactory;
        this._languagePack = languagePack;
        this._dashboardConfig = dashboardConfig;
        this._dashboardData = dashboardData;
        this._progressGameModel = progressGameModel;
        this._numberCharts = [];
    }

    initialize() {
        super.initialize();
        this._initializeNumberCharts();
        this._initializeGraphs();
        this._localiseTexts();
    }

    _initializeNumberCharts() {
        let dashboardConfigs = this._dashboardConfig.dashboardEpi;
        var self = this;
        dashboardConfigs.forEach(function (dashboardConfig, index) {
            var numberChart = self._dashboardNumberChartFactory.createNumberChart(
                self._target["DataElement" + (index + 1)],
                dashboardConfig,
                DashboardNumberChartFactory.EPI_DATA
            );
            self._numberCharts.push(numberChart);
        });
    }

    _initializeGraphs() {
        let dataSetExampleIndex = 0;

        const chapter = this._progressGameModel.chapter;
        const week = this._progressGameModel.week;
        const path = this._progressGameModel.path;
        
        let graphDataSet = [[], []];
        console.log(`[DashboardEpiTabMediator] Initialize Dashboard for chapter '${chapter}', week '${week}', path '${path}'`);
        let epidDashboardData = this._dashboardData.getDashboardDataUntil(DashboardData.NODE_EPIDATA, chapter, week, path);


        if (epidDashboardData == null) {
            return;
        }
        epidDashboardData.forEach(function (epiData, index) {
            graphDataSet[0].push(new Vector2(epiData[DashboardData.COL_WEEK], epiData[DashboardData.COL_NBR_SUSPECTED_CASES]));
            graphDataSet[1].push(new Vector2(epiData[DashboardData.COL_WEEK], epiData[DashboardData.COL_NBR_CONFIRMED_CASES]));
        });

        // Retrieve current maximum
        let maxGraph1 = Math.max(...epidDashboardData.map(o => o[DashboardData.COL_NBR_SUSPECTED_CASES]))
        let maxGraph2 = Math.max(...epidDashboardData.map(o => o[DashboardData.COL_NBR_CONFIRMED_CASES]))


        // Those adaptive scales and interval are made to adapt the graph to the data set.
        let adpativeScaleGraph1 = (maxGraph1 > 250 ? (maxGraph1 > 350 ? 0.3 : 0.5) : 0.6);
        let adpativeIntervalGraph1 = (maxGraph1 > 250 ? (maxGraph1 > 350 ? 100 : 60) : 50);

        (maxGraph2 > 100 ? 0.6 : 2.0)
        let adpativeScaleGraph2 = (maxGraph2 > 50 ? (maxGraph2 > 80 ?  (maxGraph2 > 100 ? (maxGraph2 > 130 ? 0.6 : 1.0) : 1.5) : 2.0) : 3.5);
        (maxGraph2 > 100 ? 50 : 20)
        let adpativeIntervalGraph2 = (maxGraph2 > 50 ? (maxGraph2 > 80 ? (maxGraph2 > 100 ? (maxGraph2 > 130 ? 50 : 35) : 30) : 20) : 10);

        let configurationGraph = [
            {
                scales: [26, adpativeScaleGraph1],
                interval: [1, adpativeIntervalGraph1],
                minimumBoundaries: new Vector2(19, 250),
            },
            {

                scales: [26, adpativeScaleGraph2],
                interval: [1, adpativeIntervalGraph2],
                minimumBoundaries: new Vector2(19, 40),
            }
        ];


        this._lineGraph = new Graph(
            this._target.Graph1,
            graphDataSet[0],
            configurationGraph[0].minimumBoundaries,
            {
                lineGraphDisplayOptions: new LineGraphDisplayOptions(
                    "#324141",
                    7,
                    3
                ),
                graphAxesDisplayOptions: new GraphAxesDisplayOptions(
                    new GraphAxisDisplayOptions(
                        true,
                        "#194a77",
                        3,
                        configurationGraph[0].scales[0],
                        new GraphAxisLegendDisplayOptions(true, this._languagePack.getText(`dashboard.epiTab.xAxisLabelGraph`), "#2c3c3c", 35, "18px", "'Work Sans'"),
                        new GraphAxisIntervalDisplayOptions(true, configurationGraph[0].interval[0], "#2c3c3c", 7, false, "black", 1, "18px", "'Work Sans'", false),
                    ),
                    new GraphAxisDisplayOptions(
                        false,
                        "#194a77",
                        3,
                        configurationGraph[0].scales[1],
                        new GraphAxisLegendDisplayOptions(false),
                        new GraphAxisIntervalDisplayOptions(true, configurationGraph[0].interval[1], "#2c3c3c", 7, true, "#2c3c3c", 1, "18px", "'Work Sans'", true),
                    ),
                )
            }
        );

        this._lineGraph = new Graph(
            this._target.Graph2,
            graphDataSet[1],
            configurationGraph[1].minimumBoundaries,
            {
                lineGraphDisplayOptions: new LineGraphDisplayOptions(
                    "#324141",
                    7,
                    3
                ),
                graphAxesDisplayOptions: new GraphAxesDisplayOptions(
                    new GraphAxisDisplayOptions(
                        true,
                        "#194a77",
                        3,
                        configurationGraph[1].scales[0],
                        new GraphAxisLegendDisplayOptions(true, this._languagePack.getText(`dashboard.epiTab.xAxisLabelGraph`), "#2c3c3c", 35, "18px", "'Work Sans'"),
                        new GraphAxisIntervalDisplayOptions(true, configurationGraph[1].interval[0], "#2c3c3c", 7, false, "black", 1, "18px", "'Work Sans'", false),
                    ),
                    new GraphAxisDisplayOptions(
                        false,
                        "#194a77",
                        3,
                        configurationGraph[1].scales[1],
                        new GraphAxisLegendDisplayOptions(false),
                        new GraphAxisIntervalDisplayOptions(true, configurationGraph[1].interval[1], "#2c3c3c", 7, true, "#2c3c3c", 1, "18px", "'Work Sans'", true),
                    ),
                )
            }
        );
    }

    _localiseTexts() {
        this._target.LabelTab1.text = this._languagePack.getText(`dashboard.epiTab.legendTab`);
        this._target.LabelGraph1.text = this._languagePack.getText(`dashboard.epiTab.legendGraph1`);
        this._target.LabelGraph2.text = this._languagePack.getText(`dashboard.epiTab.legendGraph2`);
    }

    destroy() {
        super.destroy();
        for (let i = 0; i < this._numberCharts.length; i++) {
            const numberChart = this._numberCharts[i];
            numberChart.destroy();
        }

        this._numberCharts = [];
        this._target.removeAllChildren();
    }
    get skin() {
        return this._target;
    }
}